import { Cookies } from '../../utils/cookies';

const FREE_GIFT_COOKIE_PREFIX = 'free-gift-';
const COOKIE_EXPIRY_DAYS = 7;

export const shouldShowFreeGiftPopup = (lineItemId: string, locale: string): boolean => {
  if (!lineItemId) return false;

  const cookieName = `${FREE_GIFT_COOKIE_PREFIX}${lineItemId}-${locale}`;
  return !Cookies.get(cookieName);
};

export const setFreeGiftPopupCookie = (lineItemId: string, locale: string): void => {
  if (!lineItemId) return;

  const cookieName = `${FREE_GIFT_COOKIE_PREFIX}${lineItemId}-${locale}`;
  Cookies.set(cookieName, 'true', {
    path: '/',
    maxAge: COOKIE_EXPIRY_DAYS * 24 * 60 * 60,
  });
};

export const removeFreeGiftPopupCookie = (lineItemId: string, locale: string): void => {
  if (!lineItemId) return;

  const cookieName = `${FREE_GIFT_COOKIE_PREFIX}${lineItemId}-${locale}`;
  Cookies.remove(cookieName, { path: '/' });
};
